import { render, staticRenderFns } from "./CourseAdmin.vue?vue&type=template&id=419a1fba&scoped=true"
import script from "./CourseAdmin.vue?vue&type=script&lang=js"
export * from "./CourseAdmin.vue?vue&type=script&lang=js"
import style0 from "./CourseAdmin.vue?vue&type=style&index=0&id=419a1fba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "419a1fba",
  null
  
)

export default component.exports